import styled from 'styled-components';

export const ButtonWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-items: center;
	gap: 0.5rem;
	width: 100%;
`;

export const ListFieldContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.25rem;
	margin: 0.25rem;
	width: 100%;
	padding: 0.25rem;
	&:hover {
		background-color: ${({ theme }) => theme.v3.colors.gray[0]};
		border-radius: 0.25rem;
		.close-icon svg {
			color: red !important;
		}
	}
`;
